import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { disableFilters, setProcRevId } from "../../../redux/partSlice";

function HandlePartsFilter({ onChange }) {
  const location = useLocation();
  const dispatch = useDispatch()
  useEffect(() => {

    let disabledOptions = ["bom_step", "bom_procedure"];

    const revisionPaths = [
      "/revision-submission/",
      "/approve-revision/",
      "/release-revision/",
      "/released-revision/",
      "/rejected-revision/",
      "/archived-revision/"
    ];


    if (revisionPaths.some(path => location.pathname.includes(path))) {
      let revid = ''
      let path  = location.pathname.split("/")
      if(revisionPaths.slice(0, 3).some(path => location.pathname.includes(path))){
        revid = path[6];
      }

      if([revisionPaths[3]].some(path => location.pathname.includes(path))){
        revid = path[7]
      }
      
      if(revisionPaths.slice(4, 6).some(path => location.pathname.includes(path))){
        revid = path[8]
      }
  
      disabledOptions.pop();
      dispatch(setProcRevId({revid,part_ref_id:path[2]}))
    }else  if(location.pathname=== "/canvas"){
      disabledOptions = []
    }

    
    dispatch(disableFilters(disabledOptions))
   
  }, [location, onChange,dispatch]);

  return null; // This component doesn’t render anything
}

export default HandlePartsFilter